export const environment = {
  production: true,
  BACKEND_OCM_API_URL: 'https://cpt-api-aws.ama-assn.org',
  apiUrl: 'https://cpt-api-aws.ama-assn.org/ocmapi',
  orgManagerURL: 'https://apps.ama-assn.org/orgManager',
  amaStore: 'https://commerce.ama-assn.org/store/',
  amaWire: 'https://wire.ama-assn.org/',
  jama: 'https://jamanetwork.com/',
  journalofethics: 'https://journalofethics.ama-assn.org/',
  becomeMember: 'https://ama-assn.org/membership',
  amaAccount: 'https://account.ama-assn.org',
  ocm: "https://ecommerce.ama-assn.org",
  createAccount: "https://login.ama-assn.org/account/signup/#sign-up",
  login: 'https://login.ama-assn.org/account/login/',
  logout: 'https://login.ama-assn.org/account/logout/',
  joinRenew: 'https://member.ama-assn.org/join-renew/',
  amaHome: 'https://www.ama-assn.org/',
  storeHome: 'https://www.ama-assn.org/practice-management/ama-store',
  freida: 'https://freida.ama-assn.org/',
  edHub: 'https://edhub.ama-assn.org/',
  insurance: 'https://www.amainsure.com/index.html',
  cpt: 'https://www.ama-assn.org/practice-management/cpt',
  amaPayment: 'https://ecommerce-payment.ama-assn.org/adv-payment/index.jsp',
  amaMembership: 'https://member.ama-assn.org/join-renew?utm_funnel=RBRVS',
  rbrvs: 'https://rbrvs.ama-assn.org/',
  findACode: 'https://www.findacode.com/newsletters/ama-cpt-assistant/',  
  onlineCoding: 'https://rbrvs.ama-assn.org/',
  memBenefits: 'https://www.ama-assn.org/amaone/membership',
  contactUs: 'https://www.ama-assn.org/form/contact-us',
  zendeskUrl: 'https://rbrvs.zendesk.com/hc/en-us/requests/new',
  ocmCryptoKey: "prod-crypto-key",
  securityOff: false
};
